import { DatePicker, Form, Input } from "antd";
import styles from "./InputDob.module.css";

const InputDate = ({
  rules,
  placeholder,
  label,
  classname,
  wrapClassname,
  name,
  value,
  onChange,
}) => {
  const handleChange = (date, dateString) => {
    console.log(date, dateString);
    onChange?.(name, dateString);
  };

  return (
    <Form.Item label={label} name={name} rules={rules}>
      <DatePicker
        className={styles.datePicker}
        placeholder={placeholder}
        onChange={handleChange}
      />
    </Form.Item>
  );
};

export default InputDate;
